// extracted by mini-css-extract-plugin
module.exports = {"MenuColumn":"styles_MenuColumn__4_C_R","sectionTitle":"styles_sectionTitle__uive2"};